import {Model} from "./Model";

export class ModelKey<ModelType extends Model> {

  constructor(private modelKey: string) {

  }

  key() {
    return this.modelKey;
  }
}
